import { useRateFieldError } from "../../hooks/useRateFieldError";
import { FC } from "react";

import { formatCurrencyAmount } from "@simplyk/common";
import { useFormContext } from "react-hook-form";

import { useRateContext } from "../../Context/RateContext";
import { useRateFieldName } from "../../hooks/useRateFieldName";

import { AmplitudeEvents } from "@/common/constants/amplitude";
import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { isMinOrUnset } from "@/common/helpers/validators";
import { useAmplitude } from "@/common/hooks/amplitude/useAmplitude";
import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardAmountInput } from "@/dashboard-design-system/DashboardAmountInput";
import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";

export const BidIncrementField: FC = () => {
  const { t } = useTranslate();
  const { locale } = useLocaleContext();
  const { organizationCurrency } = useCurrentUserContext();
  const { logAmplitudeEventCallback } = useAmplitude();
  const { isEditing, isOnboarding } = useRateContext();
  const { control } = useFormContext<StepTicketsFormData>();

  const fieldName = useRateFieldName("bidIncrement");
  const error = useRateFieldError("bidIncrement");

  return (
    <DashboardAmountInput
      control={control}
      data-test="rate-bid-increment-input"
      locale={locale}
      currency={organizationCurrency}
      label={t("dashboard", "ticketing.auctionIncrementTitle")}
      tooltipText={t("dashboard", "ticketing.auctionIncrementTooltip", {
        amount: formatCurrencyAmount({ value: 1, locale, currency: organizationCurrency }),
      })}
      onFocus={logAmplitudeEventCallback(AmplitudeEvents.TicketsFocusBidIncrement, { isEditing, isOnboarding })}
      name={fieldName}
      rules={[isMinOrUnset(100, "ticketing.rateAmountMinimum")]}
      errorMessage={error?.message && t("dashboard", `${error.message}` as never)}
    />
  );
};
